import { topshotsAPI } from '../../app/api';

const dashAPI = topshotsAPI.injectEndpoints({
  endpoints: (build) => ({
    getSalesChart: build.query<
      { _id: string; daily_total_paid: number }[],
      { fromDate: Date; toDate: Date; groupBy: 'day' | 'month' }
    >({
      query: (request) => ({
        url: `dashboard?fromDate=${request.fromDate.toISOString()}&toDate=${request.toDate.toISOString()}&groupBy=${
          request.groupBy
        }`,
        method: 'GET',
        // params: request,
      }),
    }),
    getOrdersChart: build.query<
      { _id: string; daily_orders: number }[],
      { fromDate: Date; toDate: Date; groupBy: 'day' | 'month' }
    >({
      query: (request) => ({
        url: `dashboard/orders?fromDate=${request.fromDate.toISOString()}&toDate=${request.toDate.toISOString()}&groupBy=${
          request.groupBy
        }`,
        method: 'GET',
        // params: request,
      }),
    }),
    getOrdersSummary: build.query<
      { totalOrders: number; totalOrderValue: number },
      { fromDate: Date; toDate: Date }
    >({
      query: (request) => ({
        url: `dashboard/orders-summary?fromDate=${request.fromDate.toISOString()}&toDate=${request.toDate.toISOString()}`,
        method: 'GET',
        // params: request,
      }),
    }),
  }),
});

export const {
  useGetSalesChartQuery,
  useGetOrdersChartQuery,
  useGetOrdersSummaryQuery,
} = dashAPI;
